/**
 * Created by enes.kahrovic@thebeaverhead.com on 22/10/2018.
 */

import axios from "axios";
import AxiosConfig from "../AxiosConfig";

/**
 *
 * @param page
 * @param ipp
 * @returns {function(*): Promise<AxiosResponse<any> | never>}
 */
export function fetchDomains(page = 1, ipp = 50) {
  return function(dispatch) {
    dispatch({ type: "DOMAINS_FETCH" });

    const url = "/api/domains.json?page=" + page + "&ipp=" + ipp;


    return axios
      .get(
        url,
        AxiosConfig.getAuthConfig()
      )
      .then(response => {

        dispatch({
          type: "DOMAINS_FETCH_FULFILLED",
          payload: response.data
        });
      })
      .catch(function(error) {

        dispatch({
          type: "DOMAINS_FETCH_REJECTED",
          payload: error
        });
      });
  };
}
